// components/Donor/DonorFormModal.jsx
import { Box, Typography, Modal, IconButton, Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DonorForm from "./DonorForm";

const DonorFormModal = ({
  open,
  onClose,
  onSubmit,
  editData,
  formRef,
  dropdownData,
  addDonation = false,
  onDonationSubmit,
  userRole,
}) => {
  const allowedAddDonationRoles = ["editor2", "admin1", "admin2", "superadmin"];

  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: 1100,
          background: "white",
          borderRadius: 2,
        }}
      >
        <div
          style={{
            background: "#1976D2",
            color: "white",
            padding: "16px",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h5">
            Donor Details {editData ? ` - # ${editData.donorId}` : ""}
          </Typography>
          <IconButton onClick={onClose}>
            <CloseIcon sx={{ color: "white" }} />
          </IconButton>
        </div>

        <div style={{ padding: "16px" }}>
          <DonorForm
            initialData={editData}
            ref={formRef}
            onSave={onSubmit}
            data={dropdownData}
          />
        </div>

        <Box sx={{ display: "flex", justifyContent: "flex-end", p: 2 }}>
          <Button
            variant="contained"
            onClick={() => formRef.current.submitForm()}
          >
            {editData ? "Update Donor" : "Add Donor"}
          </Button>
          {addDonation && allowedAddDonationRoles.includes(userRole) && (
            <>
              <Button
                variant="contained"
                color="primary"
                onClick={onDonationSubmit}
                sx={{ ml: 1 }}
              >
                Add Donation
              </Button>
            </>
          )}

          <Button
            variant="contained"
            color="error"
            sx={{ ml: 1 }}
            onClick={onClose}
          >
            Close
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default DonorFormModal;
